import { createSlice } from '@reduxjs/toolkit'

import * as reducers from './reducers'

const commentsSlice = createSlice({
  name: 'comments',
  initialState: {},
  reducers
})

export default commentsSlice
